import { render, staticRenderFns } from "./tyoskentelyjaksot-yek.vue?vue&type=template&id=3d1c6b05&scoped=true&"
import script from "./tyoskentelyjaksot-yek.vue?vue&type=script&lang=ts&"
export * from "./tyoskentelyjaksot-yek.vue?vue&type=script&lang=ts&"
import style0 from "./tyoskentelyjaksot-yek.vue?vue&type=style&index=0&id=3d1c6b05&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d1c6b05",
  null
  
)

export default component.exports